package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class ApiKeyRepository(private val httpClient: HttpClient) {
    suspend fun getApiKeys(workplaceId: Long): Result<List<ApiKeyDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/api-keys").body()
    }
    suspend fun createApiKey(workplaceId: Long, req: CreateApiKeyRequest): Result<ApiKeyCreatedDto> = runCatching {
        httpClient.post("workplaces/$workplaceId/api-keys") { setBody(req) }.body()
    }
    suspend fun deleteApiKey(keyId: Long): Result<Unit> = runCatching {
        httpClient.delete("api-keys/$keyId")
    }
    suspend fun getWebhooks(workplaceId: Long): Result<List<WebhookDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/webhooks").body()
    }
    suspend fun createWebhook(workplaceId: Long, req: CreateWebhookRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/webhooks") { setBody(req) }
    }
    suspend fun toggleWebhook(webhookId: Long): Result<Unit> = runCatching {
        httpClient.put("webhooks/$webhookId/toggle")
    }
    suspend fun deleteWebhook(webhookId: Long): Result<Unit> = runCatching {
        httpClient.delete("webhooks/$webhookId")
    }
}
